<template>
  <v-container
    fill-height
    fluid
    class="verify-bg d-flex flex-column align-center justify-center"
  >
    <v-card class="pa-6 text-center elevation-12 rounded-xl verify-card">
      <v-img
        src="@/assets/nikah-connect-logo.png"
        contain
        max-width="100"
        class="mx-auto mb-4"
      />
      <h2 class="font-weight-bold mb-2" style="color:#2A6465;">
        {{ title }}
      </h2>

      <p class="grey--text text--darken-1 mb-4" v-if="message">
        {{ message }}
      </p>

      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        size="36"
        class="mb-4"
      ></v-progress-circular>

      <v-btn
        v-if="success"
        color="primary"
        large
        rounded
        class="mt-4"
        @click="goToApp"
      >
        Go to Nikah Connect
      </v-btn>

      <p v-if="success" class="mt-5 grey--text text--darken-1" style="font-size:13px;">
        “When a man marries, he has fulfilled half of his religion,
        so let him fear Allah regarding the remaining half.” <br />
        <span style="font-size:12px;">(Tirmidhi 1086)</span>
      </p>
    </v-card>
  </v-container>
</template>

<script>
import authService from "@/modules/Authentication/service.js";

export default {
  name: "VerifyEmail",
  data() {
    return {
      title: "Verifying your email...",
      message: "Please wait while we confirm your account.",
      loading: true,
      success: false,
    };
  },
  async created() {
    const token = this.$route.query.token;
    if (!token) {
      this.title = "Invalid or Missing Token";
      this.message = "It looks like your verification link is invalid or expired.";
      this.loading = false;
      return;
    }

    try {
      const res = await authService.verifyEmail({ token });
      console.log("Verification Response:", res);
      this.title = "Alhamdulillah! 🎉 You are Verified.";
      this.message =
        "Your email has been successfully verified. You can now log in and begin your Nikah journey with confidence.";
      this.success = true;
    } catch (error) {
      console.error("Verification error:", error);
      this.title = "Verification Failed";
      this.message =
        "We couldn’t verify your email. The link may have expired or been used already.";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    goToApp() {
      this.$router.push({ name: "authentication-login" });
    },
  },
};
</script>

<style scoped>
.verify-bg {
  background: linear-gradient(145deg, #f8fafc, #eaf3ef);
  min-height: 100vh;
  width: 100vw;
}
.verify-card {
  max-width: 420px;
  text-align: center;
  border-radius: 18px;
  background: #fff;
}
</style>